<form [formGroup]="multilingualForm" role="form" class="d-flex flex-column w-100" *transloco="let t">

  @if (multilingualForm?.get('languages')) {
    <div formArrayName="languages">
      @for (control of multilingualForm.get('languages')['controls']; track control; let i = $index) {
        <ng-container
          [formGroupName]="i">
          <div class="input-self">
            @if (labelTextTranslationKey || labelText) {
              <label for="{{getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')}}"
                class="form-label">{{labelTextTranslationKey ?
                t(labelTextTranslationKey) : labelText}}
              </label>
            }
        <div class="input-group textarea-control mb-3" [ngClass]="{
          'ng-invalid':
            multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.invalid &&
            (multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.touched || multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.dirty),
          'ng-valid':
            multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.valid &&
            multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.touched &&
            multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.dirty
        }">
              <span class="input-group-text">
                {{getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'name')}}
              </span>
              @if (!rows) {
                <input class="form-control" type="text" [disabled]="loading"
                  [formControlName]="getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')"
                  [id]="getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')"
                  [placeholder]="placeholderTranslationKey ? t(placeholderTranslationKey) : placeholderText"
                  (change)="updateValidity()" />
              }
              @if (rows) {
                <textarea class="form-control" [rows]="rows" [disabled]="loading"
                  [formControlName]="getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')"
                  [id]="getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')"
                  [placeholder]="placeholderTranslationKey ? t(placeholderTranslationKey) : placeholderText"
                  (change)="updateValidity()">
                </textarea>
              }
              @if (
                multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.errors?.maxlength && multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.too_long') }}
                </div>
              }
              @if (
                multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.errors?.minlength && multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.touched
                ) {
                <div class="invalid-feedback">
                  {{ t('common.too_short') }}
                </div>
              }
              @if (
                multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.errors?.required &&
                multilingualForm.get('languages')['controls'][i]['controls'][getControlLanguageProperty(multilingualForm.get('languages')['controls'][i]['controls'],'iso')]?.dirty
                ) {
                <div class="invalid-feedback">
                  {{ t('common.required') }}
                </div>
              }
              @if (errorTranslationKey) {
                <div class="text-danger">
                  {{ t(errorTranslationKey) }}
                </div>
              }
            </div>
          </div>
        </ng-container>
      }
    </div>
  }

  <button [disabled]="!multilingualForm.valid || loading" (click)="submit()" class="btn btn-primary align-self-end" type="button"
    id="button-addon2">
    @if (loading) {
      <multisite-loader-globe-animation-detail [width]="24" [height]="24">
      </multisite-loader-globe-animation-detail>
    }
    {{t('common.submit')}}
  </button>

</form>